import { IState } from 'common/interfaces/state';
import { CardButton } from 'components/action';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./StateItem.css');
const arrow = require('assets/blue arrow.svg');

// Props
interface IStateItemProps {
    onClick?: (stateId: string, stateName: string) => void;
    state: IState;
}

// Component
@observer
export class StateItem extends React.Component<IStateItemProps, {}> {
    static get defaultProps(): IStateItemProps {
        return {
            onClick: null,
            state: null,
        };
    }

    constructor(props: IStateItemProps) {
        super(props);
    }

    public render() {
        // Destructure
        const { state } = this.props;

        // Render
        return (
            <div className={s.stateListItem}>
                <CardButton
                    className={s.stateListButton}
                    onClick={this.handleStateClick}
                >
                    <p className={s.stateName}>
                        {state.id && <strong>{state.id}</strong>}
                        {state.name && <span>{state.name}</span>}
                    </p>

                    {state.leadsCount !== null && (
                        <p className={s.stateLeadsCount}>
                            <strong>{state.leadsCount}</strong>
                            <em>{` lead${state.leadsCount > 0 ? 's' : ''}`}</em>
                        </p>
                    )}
                </CardButton>
            </div>
        );
    }

    private handleStateClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (
            this.props.onClick &&
            (this.props.state.leadsCount === null ||
                this.props.state.leadsCount > 0)
        ) {
            this.props.onClick(this.props.state.id, this.props.state.name);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/StateItem.tsx